import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-icon-not-selectable',
  styleUrl: 'lab-ds-icon-not-selectable.css',
  shadow: true,
})
export class LabDsIconNotSelectable {
  @Prop() color: string;

  @Prop() icon!: string;

  @Prop() size: 'x-large' | 'large' | 'medium' | 's-medium' | 'small' | 'x-small' | 'xx-small' = 'x-small';

  render() {
    return <span class={`material-symbols-outlined ${this.size} notranslate`}>{this.icon}</span>;
  }
}
